/* eslint-disable new-cap */
import 'jspdf-autotable';
import jsPDF from 'jspdf';
import moment from 'moment';
import { generateData } from './generate-data';

export function handleExportPdf(columns, renderData, exportData, columnsForExport, title) {
  if (exportData && columnsForExport) {
    const doc = new jsPDF();

    const columnTitles = columnsForExport.map(
      (columnDef) => columnDef.title,
    );

    const pdfData = generateData(exportData, columnsForExport);

    doc.autoTable({
      head: [columnTitles],
      body: pdfData,
    });
    const epoch = Date.now();

    doc.save(
      `${title}_${moment(new Date(epoch)).format(
        'DD-MM-YYYY_HH.mm',
      )}.pdf`,
    );
  } else {
    const doc = new jsPDF();

    const columnTitles = columns.map(
      (columnDef) => columnDef.title,
    );

    const pdfData = generateData(renderData, columns);

    doc.autoTable({
      head: [columnTitles],
      body: pdfData,
    });
    const epoch = Date.now();

    doc.save(
      `${title}_${moment(new Date(epoch)).format(
        'DD-MM-YYYY_HH.mm',
      )}.pdf`,
    );
  }
}
